import { render, staticRenderFns } from "./SystemMeasureValidationsModal.vue?vue&type=template&id=1280c183&"
import script from "./SystemMeasureValidationsModal.vue?vue&type=script&lang=js&"
export * from "./SystemMeasureValidationsModal.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports